import React from "react";
import { Palette, Check } from "lucide-react";
import { toast } from "sonner";
import { useTheme } from "@/context/ThemeContext";

const OPTIONS = [
  { id: "aurora", name: "Aurora", desc: "Sombre · néon cyan (par défaut)", swatch: ["#05060E", "#00E5FF", "#7C3AED"] },
  { id: "ember", name: "Ember", desc: "Sombre · néon chaleureux", swatch: ["#0A0708", "#FF4500", "#FF0055"] },
  { id: "light", name: "Aurora White", desc: "Clair · doux et reposant", swatch: ["#E0E5F1", "#00B4D8", "#7C3AED"] },
  { id: "daylight", name: "Daylight", desc: "Clair · corail · violet · turquoise", swatch: ["#F0E7FF", "#FF6F91", "#21C7B7"] },
  { id: "mpower", name: "M Power", desc: "Sombre · rayures M (bleu · navy · rouge)", swatch: ["#050609", "#2E6BFF", "#E4002B"] },
  { id: "mlight", name: "M Light", desc: "Clair · bleu électrique · rouge M", swatch: ["#EEF3FB", "#0057FF", "#E4002B"] },
];

export const AppearanceSettings = () => {
  const { theme, setTheme } = useTheme();

  const pick = (opt) => {
    setTheme(opt.id);
    toast.success(`Thème « ${opt.name} » appliqué`);
  };

  return (
    <div className="glass rounded-md p-6 mb-6" data-testid="appearance-settings">
      <div className="flex items-center gap-2.5 mb-1">
        <span className="w-8 h-8 grid place-items-center rounded-sm bg-aurora-cyan/12 text-aurora-cyan"><Palette className="w-4 h-4" /></span>
        <h2 className="font-display text-lg font-bold uppercase tracking-tight">Apparence</h2>
      </div>
      <p className="font-mono text-[11px] text-zinc-500 mb-5">Choisissez le thème de l'application. Enregistré sur cet appareil.</p>

      <div className="grid grid-cols-2 gap-3">
        {OPTIONS.map((opt) => {
          const active = theme === opt.id;
          return (
            <button
              key={opt.id}
              onClick={() => pick(opt)}
              data-testid={`theme-option-${opt.id}`}
              className={`theme-preview-host relative text-left rounded-md p-3 border transition-all ${active ? "border-aurora-cyan bg-aurora-cyan/10" : "border-white/10 hover:border-white/25"}`}
            >
              <div className="flex gap-1.5 mb-2.5">
                {opt.swatch.map((c, i) => (
                  <span key={i} className="w-7 h-7 rounded-sm border border-white/10" style={{ backgroundColor: c }} />
                ))}
              </div>
              <div className="text-sm font-semibold flex items-center gap-1.5">
                {opt.name}
                {active && <Check className="w-3.5 h-3.5 text-aurora-cyan" />}
              </div>
              <div className="font-mono text-[10px] text-zinc-500 mt-0.5">{opt.desc}</div>
              <span
                className="theme-preview-stripe mt-2.5"
                style={{ backgroundImage: `linear-gradient(90deg, ${opt.swatch[1]} 0 25%, ${opt.swatch[2]} 25% 50%, ${opt.swatch[1]} 50% 75%, ${opt.swatch[2]} 75% 100%)` }}
              />
            </button>
          );
        })}
      </div>
    </div>
  );
};
